import { createContext, useContext } from "react";
import { initialChatState, initialDeepInsightsState } from "@/constants/user";
import { initialCustomWorkspaceState } from "@/constants/user";
import { initialReportState } from "@/constants/user";
import { initialModalState } from "@/constants/user";
import { signOut } from "../../lib/serverComm";
import { LOGOUT_URL } from "../../constants/api";
import type { ParitaWorkspace } from "@/common/user";
import type { AuthenticationContextData } from "@/types/authContext";

const handleLogout = async () => {
  try {
    await signOut();
    localStorage.removeItem("authToken");
    window.location.href = LOGOUT_URL;
  } catch (error) {
    console.error("Logout failed:", error);
  }
};

export type ActionType = { type: string; payload?: any }; // eslint-disable-line @typescript-eslint/no-explicit-any

export const defaultAuthenticationContextData: AuthenticationContextData = {
  userData: null,
  chatState: initialChatState,
  customWorkspaceState: initialCustomWorkspaceState,
  modalState: initialModalState,
  reportState: initialReportState,
  deepInsightsState: initialDeepInsightsState,
  handleLogout,
};

export const AuthenticationContext = createContext({
  state: defaultAuthenticationContextData,
  dispatch: (() => {}) as React.Dispatch<ActionType>,
} as {
  state: AuthenticationContextData;
  dispatch: React.Dispatch<ActionType>;
});

// Custom hook for using the context
export function useAuthenticationContext() {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error("useAppState must be used within an AppProvider");
  }
  return context;
}

export function useCurrentAccountId() {
  const { state } = useAuthenticationContext();
  const domo_instance_domain = state.userData?.workspaces.find(
    (w: ParitaWorkspace) => w.is_current,
  )?.domo_instance_domain;
  if (!domo_instance_domain) {
    throw new Error("Domo instance domain is not available");
  }
  return domo_instance_domain;
}

export function useCurrentWorkspace() {
  const { state } = useAuthenticationContext();

  const workspace = state.userData?.workspaces.find(
    (w: ParitaWorkspace) => w.is_current,
  );
  if (!workspace) {
    throw new Error("Workspace data is not available");
  }
  return workspace;
}
